function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useMemo, useState } from 'react';
import cx from 'clsx';
import { observer } from 'mobx-react-lite';
import Store from '@unmapped/core/state/Store';
import Unmapped from '@unmapped/core/Unmapped';
import { decorateName } from '@unmapped/core/utils';
import ResultsList from '@unmapped/core-ui/results/ResultsList';
import FuzzySearchFilter from '@unmapped/core-ui/filters/FuzzySearchFilter';
import { adapterMap } from './definitions/shared';
import { FocusedLocationContext, useDataSource, useFilterSet, useSortManager } from './hooks';
import MapWrapper from './MapWrapper';
import ResultItem from './overrides/ResultItem';
import PopoverContent from './overrides/PopoverContent';
import PopoverCloseButton from './overrides/PopoverCloseButton';
import { ACTIVE_DATASET } from '../apiConfig';
import { blindAssert } from './utils';
import MapOnlyLayout from '@unmapped/core-ui/layouts/MapOnlyLayout';
export const GenericFinder = observer(({}) => {
  let dataset = ACTIVE_DATASET;
  const filterSet = useFilterSet(dataset);
  const [focusedLocation, setFocusedLocation] = useState(null);
  const store = useMemo(() => new Store(filterSet, adapterMap[dataset]), []);
  useDataSource(dataset, store);
  return /*#__PURE__*/React.createElement(Unmapped, {
    store: store
  }, /*#__PURE__*/React.createElement(FocusedLocationContext.Provider, {
    value: {
      focusedLocation,
      setFocusedLocation
    }
  }, /*#__PURE__*/React.createElement(MapOnlyLayout, {
    components: {
      'results/ResultItem': ResultItem,
      'GoogleMaps/Popover/PopoverCloseButton': PopoverCloseButton,
      'GoogleMaps/Popover/PopoverContent': PopoverContent
    },
    styles: (name, classNames) => {
      if (name === 'controls/CheckboxInput') {
        blindAssert(classNames);
        return _objectSpread(_objectSpread({}, classNames), {}, {
          'CheckboxContainer': cx(classNames.CheckboxContainer, 'custom-control', 'custom-checkbox'),
          'CheckboxInput': cx(classNames.CheckboxInput, 'custom-control-input'),
          'CheckboxLabel': cx(classNames.CheckboxLabel, 'custom-control-label'),
          'CheckboxLabelText': cx(classNames.CheckboxLabelText, 'custom-control-label-text')
        });
      } else return classNames[name];
    },
    map: /*#__PURE__*/React.createElement(MapWrapper, null)
  })));
});
export default GenericFinder;
const ResultsView = decorateName(observer(({}) => {
  useSortManager();
  const {
    setFocusedLocation
  } = useContext(FocusedLocationContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FuzzySearchFilter, {
    name: "search",
    showSortIndicator: true
  }), /*#__PURE__*/React.createElement(ResultsList, {
    onResultClick: (r, e) => {
      e.preventDefault();
      e.stopPropagation();
      setFocusedLocation(r);
    }
  }));
}), 'ResultView');